import { useState, useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { AppShell, AppShellHeader, AppShellNavbar, AppShellMain, Loader, Image, Center, Stack, Tooltip, UnstyledButton } from '@mantine/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCodeCompare, faChartSimple, faFileExport, faBell, faPersonWalkingDashedLineArrowRight, faFileInvoice } from '@fortawesome/free-solid-svg-icons';
import classes from './ProtectedRoutes.module.css';
import wallpaper from '../../content/Images/Icon.jpeg';

const mockdata = [
  { icon: faBell, label: 'Alertas', path: 'Home' },
  { icon: faCodeCompare, label: 'Conciliacion', path: 'Conciliaciones' },
  { icon: faFileExport, label: 'Reportes', path: 'Reportes' },
  { icon: faFileInvoice, label: 'Reportes RDI', path: 'ReportesRDI' },
  { icon: faChartSimple, label: 'Cifras de control RDI', path: 'CifrasRDI' },
];

function NavbarLink({ icon: Icon, label, active, onClick }) {
  return (
    <Tooltip label={label} position="right" transitionProps={{ duration: 0 }}>
      <UnstyledButton onClick={onClick} className={classes.link} data-active={active || undefined}>
        <FontAwesomeIcon icon={Icon} size="2x" />
      </UnstyledButton>
    </Tooltip>
  );
}

const ProtectedRoute = () => {
  const [active, setActive] = useState(0);
  const { isAuthenticated, isLoading, loginWithRedirect, logout, user, getAccessTokenSilently } = useAuth0();
  const navigate = useNavigate();
  const location = useLocation();
  const [tokenReady, setTokenReady] = useState(false);

  useEffect(() => {
    if (!isLoading && !isAuthenticated) {
      loginWithRedirect();
    }
  }, [isLoading, isAuthenticated, loginWithRedirect]);

  // Garantizar que el token esté en sessionStorage ANTES de renderizar
  // cualquier componente hijo que haga peticiones al API.
  useEffect(() => {
    if (!isAuthenticated) return;
    if (sessionStorage.getItem('token')) {
      setTokenReady(true);
      return;
    }
    const fetchToken = async () => {
      try {
        const token = await getAccessTokenSilently();
        sessionStorage.setItem('token', token);
        if (user?.nickname) sessionStorage.setItem('user', user.nickname);
      } catch (e) {
        console.error('[ProtectedRoute] No se pudo obtener el token:', e.message);
      } finally {
        setTokenReady(true);
      }
    };
    fetchToken();
  }, [isAuthenticated, getAccessTokenSilently, user]);

  const handleClick = (index, path) => {
    setActive(index);
    navigate('/' + path);
  };

  const cierre_sesion = () => {
    sessionStorage.removeItem('token');
    sessionStorage.removeItem('user');
    logout({ logoutParams: { returnTo: window.location.origin } });
  };

  const links = mockdata.map((link, index) => (
    <NavbarLink
      {...link}
      key={link.label}
      active={index === active}
      onClick={() => handleClick(index, link.path)}
    />
  ));

  if (isLoading) {
    return (
      <Center style={{ height: '100vh' }}>
        <Loader color="rgba(250, 0, 115, 1)" type="dots" size={200} />
      </Center>
    );
  }

  if (isAuthenticated || sessionStorage.getItem("token") != null) {
    return (
      <AppShell>
        <AppShellHeader></AppShellHeader>
        <AppShellNavbar p={0}>
          <nav className={classes.navbar}>
            <Center>
              <Image src={wallpaper} alt="Logo" fit="cover" radius="md" style={{ width: '100%', objectPosition: 'center', marginBottom: '1rem' }} />
            </Center>
            <div className={classes.navbarMain}>
              <Stack justify="center" gap={0}>{links}</Stack>
            </div>
            <Stack justify="center" gap={0}>
              <NavbarLink icon={faPersonWalkingDashedLineArrowRight} onClick={cierre_sesion} label="Logout" />
            </Stack>
          </nav>
        </AppShellNavbar>
        <AppShellMain>
          <div className={classes.AppShellMain}>
            {tokenReady ? <Outlet /> : (
              <Center style={{ height: '100%' }}>
                <Loader color="rgba(250, 0, 115, 1)" type="dots" size={200} />
              </Center>
            )}
          </div>
        </AppShellMain>
      </AppShell>
    );
  }

  return null;
};

export default ProtectedRoute;
